import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAllUsers, deleteUser } from "../server/rolesAllApi";
import axios from "axios";
// for deletion
import { Modal } from "react-bootstrap";
import {
  Snackbar,
  Alert,
  CircularProgress,
  MenuItem,
  TextField,
} from "@mui/material";

const EnRolledCourseList = () => {
  const [assignCourse, setAssignCourses] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [token, setToken] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [serialNumbers, setSerialNumbers] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedCourseCategory, setSelectedCourseCategory] = useState("");
  const [courseCategories, setCourseCategories] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [courses, setCourses] = useState([]);
  // for deletion
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
  }, []);

  useEffect(() => {
    if (token) {
      fetchAssignCourse();
      fetchdepartment();
    }
  }, [token, currentPage, itemsPerPage, searchTerm, selectedDepartment]);

  const fetchAssignCourse = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-enrolled-course?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // setAssignCourses(response.data.data); // Update to your API structure
      // setTotalItems(response.data.pagination.totalItems); // Assuming your API returns this
      // // console.log("total Items", totalItems);

      // console.log("Response received:", response);
      const startSerial = (currentPage - 1) * itemsPerPage + 1; // Start serial for the current page
      const usersWithSerial = response.data.data.map((item, index) => ({
        ...item,
        serial: startSerial + index, // Calculate serial number correctly
        statusToggle: !item.status,
      }));
      setAssignCourses(usersWithSerial);
      setSerialNumbers(usersWithSerial.map((t) => t.serial));
      setTotalItems(response.data.pagination.totalItems); // Set totalItems for pagination
      setTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error("Failed to fetch tutors:", error);
      setError("Failed to fetch tutors.");
    } finally {
      setLoading(false);
    }
  };

  const fetchdepartment = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-batches-enroll`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setBatches(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };
  const updateBatch = async (batch_id, enroll_id) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/assign-batches-enroll`,
        {
          batch_id: batch_id,
          enroll_id: enroll_id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // setBatches(response.data.data);
      if (response.status === 200) {
        setSnackbarMessage("Batch assigned successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        handleCloseDeleteModal();
        fetchAssignCourse();
      }
    } catch (err) {
      console.error(err);
      setSnackbarMessage("Failed to assign Batch. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditAssignCourse = (assignCourse) => {
    navigate("/assigncourse-edit", { state: { assignCourse } });
  };

  // for Deletion
  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleConfirmDelete = async () => {
    try {
      // Your delete logic here
      await handleDeletetutor(itemToDelete);
      handleCloseDeleteModal();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const handleDeletetutor = async (assignCourse) => {
    try {
      // const res = await deletetutor(assignCourse._id, reqHeader);
      const response = await fetch(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/delete-assignCourse/${assignCourse._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setSnackbarMessage("Deleted successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        handleCloseDeleteModal();

        fetchAssignCourse();
      }
    } catch (err) {
      console.error(err);
      setSnackbarMessage("Failed to delete. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleToggleStatus = async (course) => {
    try {
      const updatedStatus = !course.status; // Toggle the current status
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/assigncourse-status-update/${course._id}`,
        { status: updatedStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // Update the status locally
        fetchAssignCourse((prevcourse) =>
          prevcourse.map((b) =>
            b._id === course._id ? { ...b, status: updatedStatus } : b
          )
        );

        setSnackbarMessage("Status updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to toggle course status:", error);
      setSnackbarMessage("Failed to update status. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <div className="card h-100 p-0 radius-12">
      {loading && (
        <div className="loader-container" style={styles.loaderContainer}>
          <CircularProgress />
        </div>
      )}
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <form
            className="search px-10"
            style={{
              border: "1px solid #6b7280",
              display: "flex",
              alignItems: "center",
              borderRadius: "10px",
            }}
            onSubmit={(e) => e.preventDefault()}
          >
            <Icon
              icon="ion:search-outline"
              className="icon"
              style={{ marginRight: "10px" }}
            />
            <input
              type="text"
              className="bg-base h-40-px"
              name="search"
              onChange={(e) => {
                let value = e.target.value;

                // Remove leading/trailing spaces & allow only alphanumeric and spaces
                value = value.replace(/[^a-zA-Z0-9\s]/g, "").trimStart();

                setSearchTerm(value);
                setCurrentPage(1); // Reset to the first page
              }}
              value={searchTerm}
              placeholder="Search"
            />
          </form>
        </div>
        {/* <Link
          to="/assigncourse-add"
          className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
        >
          <Icon
            icon="ic:baseline-plus"
            className="icon text-xl line-height-1"
          />
          Add New
        </Link> */}
      </div>
      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th scope="col">
                  <div className="d-flex align-items-center gap-10">
                    {/* <div className="form-check style-check d-flex align-items-center">
                      <input
                        className="form-check-input radius-4 border input-form-dark"
                        type="checkbox"
                        name="checkbox"
                        id="selectAll"
                      />
                    </div> */}
                    S.L
                  </div>
                </th>
                <th scope="col">User Name</th>
                <th scope="col">User Type</th>
                <th scope="col">Course</th>
                <th scope="col">Batch</th>
                <th scope="col">Batch Start Date</th>
                <th scope="col">Batch End Date</th>
                {/* <th scope="col">Fees</th>
                <th scope="col">Duration</th>
                <th scope="col">Brief</th> */}
                <th scope="col">Created At</th>
                {/* <th scope="col" className="text-center">
                  Status
                </th>
                <th scope="col" className="text-center">
                  Action
                </th> */}
              </tr>
            </thead>
            <tbody>
              {assignCourse?.length > 0 ? (
                assignCourse.map((assignCourse, index) => (
                  <tr key={assignCourse?._id}>
                    <td>
                      <div className="d-flex align-items-center gap-10">
                        {assignCourse.serial}
                      </div>
                    </td>
                    <td>{assignCourse?.user_details?.name}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {assignCourse?.user_details?.user_type}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td
                      style={{
                        width: "369px",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {assignCourse?.course_details?.coursename}
                      </span>
                    </td>
                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        <TextField
                          select
                          label="Select Batch"
                          value={assignCourse?.batch_details?._id || ""}
                          onChange={(e) => {
                            updateBatch(e.target.value, assignCourse._id);
                          }}
                          variant="outlined"
                          size="small"
                          sx={{
                            width: "280px", // Set width to 200px
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "#6b7280", // Gray border
                                borderRadius: "10px",
                              },
                              "&:hover fieldset": {
                                borderColor: "#6b7280", // Gray border on hover
                                borderRadius: "10px",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#6b7280", // Gray border when focused
                                borderRadius: "10px",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              color: "#d1d5db", // Light gray label text
                            },
                            "& .MuiInputLabel-root.Mui-focused": {
                              color: "#d1d5db", // Light gray label text when focused
                            },
                            "& .MuiOutlinedInput-input": {
                              color: "#d1d5db", // Light gray input text
                            },
                            "& .MuiSvgIcon-root": {
                              color: "#d1d5db", // Light gray dropdown arrow
                            },
                          }}
                        >
                          <MenuItem value="">Select Batch</MenuItem>
                          {batches
                            .filter(
                              (batch) =>
                                batch.course_id ===
                                assignCourse?.course_details?._id
                            )
                            .map((batch) => (
                              <MenuItem key={batch._id} value={batch._id}>
                                {batch?.batch_name}
                              </MenuItem>
                            ))}
                          {!batches.some(
                            (batch) =>
                              batch.course_id ===
                              assignCourse?.course_details?._id
                          ) && (
                            <MenuItem value="" disabled>
                              No batches available for this course
                            </MenuItem>
                          )}
                        </TextField>
                      </span>
                    </td>

                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {assignCourse?.batch_details?.batch_start_duration ? (
                          <>
                            {new Date(
                              assignCourse?.batch_details?.batch_start_duration
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })}{" "}
                            {/* {new Date(
                          assignCourse?.batch_details?.batch_start_duration
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })} */}
                          </>
                        ) : (
                          "Not Set"
                        )}
                      </span>
                    </td>
                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {assignCourse?.batch_details?.batch_end_duration ? (
                          <>
                            {new Date(
                              assignCourse?.batch_details?.batch_end_duration
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })}{" "}
                            {/* {new Date(
                              assignCourse?.batch_details?.batch_end_duration
                            ).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })} */}
                          </>
                        ) : (
                          "Not Set"
                        )}
                      </span>
                    </td>
                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {new Date(assignCourse.createdAt).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          }
                        )}{" "}
                        {new Date(assignCourse.createdAt).toLocaleTimeString(
                          [],
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )}
                      </span>
                    </td>
                    {/* <td className="text-center">
                      <button
                        onClick={() => handleToggleStatus(assignCourse)}
                        className={`bg-${
                          assignCourse.status ? "success" : "danger"
                        }-focus text-${
                          assignCourse.status ? "success" : "danger"
                        }-600 border border-${
                          assignCourse.status ? "success" : "danger"
                        }-main px-24 py-4 radius-4 fw-medium text-sm`}
                        style={{ cursor: "pointer" }}
                      >
                        {assignCourse.status ? "Active" : "Inactive"}
                      </button>
                    </td> */}
                    {/* <td className="text-center">
                      <div className="d-flex align-items-center gap-10 justify-content-center">
                        <button
                          type="button"
                          className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => handleEditAssignCourse(assignCourse)}
                        >
                          <Icon icon="lucide:edit" className="menu-icon" />
                        </button>
                        <button
                          type="button"
                          className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => handleDeleteClick(assignCourse)}
                        >
                          <Icon
                            icon="fluent:delete-24-regular"
                            className="menu-icon"
                          />
                        </button>
                      </div>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No assign course found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
            Showing{" "}
            {assignCourse.length === 0
              ? "0"
              : `${(currentPage - 1) * itemsPerPage + 1}`}{" "}
            to {Math.min(currentPage * itemsPerPage, totalItems)} of{" "}
            {totalItems} entries
          </span>

          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            {/* Previous Button */}
            <li className="page-item">
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={() => handlePageChange(currentPage - 1)}
                style={{
                  pointerEvents: currentPage === 1 ? "none" : "auto",
                  opacity: currentPage === 1 ? 0.5 : 1,
                }}
              >
                <Icon icon="ep:d-arrow-left" />
              </Link>
            </li>

            {/* Current Page Number */}
            <li className="page-item">
              <span className="page-link bg-primary-600 text-white fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md">
                {currentPage}
              </span>
            </li>

            {/* Next Button */}
            <li className="page-item">
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={() => handlePageChange(currentPage + 1)}
                style={{
                  pointerEvents: currentPage === totalPages ? "none" : "auto",
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
              >
                <Icon icon="ep:d-arrow-right" />
              </Link>
            </li>
          </ul>
        </div>
        {/* for deletion */}
        <Modal
          show={showDeleteModal}
          onHide={handleCloseDeleteModal}
          centered
          backdrop="static"
          size="sm"
        >
          <div className="modal-content radius-16 bg-base">
            <div className="modal-body p-24 text-center">
              <span className="mb-16 fs-1 line-height-1 text-danger d-block">
                <Icon icon="fluent:delete-24-regular" className="menu-icon" />
              </span>
              <h6 className="text-lg fw-semibold text-primary-light mb-0">
                Are you sure you want to delete this assign course?
              </h6>
              <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                <button
                  type="button"
                  onClick={handleCloseDeleteModal}
                  className="w-50 border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleConfirmDelete}
                  className="w-50 btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </Modal>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EnRolledCourseList;
